export const DEFAULT_KEYCLOAK_URL = 'https://login.fleetgo.com/';
export const DEFAULT_KEYCLOAK_REALM = 'FleetGO';
export const DEFAULT_KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'fleetgo-ai-prd';
